<template>
  <div class="acompanhamento-mensal-page">
    <div class="card card-custom">
      <div class="card-body">
        <GlobalCampanhaPanel />
      </div>
    </div>
  </div>
</template>

<script lang="js">
import GlobalCampanhaPanel from "../../shared/components/GlobalCampanhaPanel.vue";

export default {
  components: {
    GlobalCampanhaPanel
  }
};
</script>

<style lang="scss" scoped>
.acompanhamento-mensal-page {
  min-height: 65svh;
}

.card-custom {
  min-height: 65svh;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-custom .card-body {
  padding: 0;
  flex: 1;
  min-height: 0;
}
</style>
